export const nextAttributeMap = (
  current: Record<string, unknown> | undefined,
  id: string,
  value: unknown
) => ({
  ...current,
  [id]: value,
});

export const attributeStoreForField = (
  isEntityTagAttr: boolean,
  shared: Record<string, unknown>,
  unique: Record<string, unknown>
) => (isEntityTagAttr ? unique : shared);
